import "@/painting-app/scss/style.scss"

let isAppLoaded = false

document.addEventListener("click", async (event) => {
    const target = event.target.closest(".open-painting-app a")
    if (!target) return

    event.preventDefault()

    const paintingAppElement = document.getElementById("painting-app")

    if (isAppLoaded) {
        paintingAppElement.style.display = "block"
        document.body.classList.add("painting-app-active")
        return
    }

    try {
        const [{createApp}, {createPinia}, {default: PaintingApp}] = await Promise.all([
            import("vue"),
            import("pinia"),
            import("@/painting-app/PaintingApp.vue")
        ])

        const app = createApp(PaintingApp)
        app.use(createPinia())
        app.mount("#painting-app")

        isAppLoaded = true
        document.body.classList.add("painting-app-active")
    } catch (error) {
        console.error("Error loading Painting App:", error)
    }
})
